<template>
  <div class="complete notranslate">
    <p v-if="order && order.orderReason" class="mb30" :data-status="orderResult.status">{{orderResult.message}}</p>
    <div v-else-if="completeFrom === 'expressCheckin'">
      <p data-status="paid">{{locale.complete_expresscheckin}}</p>
      <div class="mb30 message">{{locale.message_complete_expresscheckin}}</div>
    </div>
    <p v-else class="mb30" data-status="paid">{{locale.complete_request}}</p>
    <div v-if="!isPrivate" class="btns">
      <router-link v-if="order && order.orderReason && !isPublic" :to="{name: 'myPayment', params: {ln: ln}}" class="btn btnRound">{{locale.payment_list}}</router-link>
      <router-link :to="{name: 'main', params: {ln: ln}}" class="btn btnRound">{{locale.go_main}}</router-link>
    </div>
    <div v-else class="btns">
      <router-link v-if="order && order.orderReason === 'paid'" :to="{name: 'myPaymentItem', params: {ln: ln, orderId: order.orderId}}" class="btn btnRound">{{locale.payment_list}}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Complete',
  props: [
    'ln',
    'locale',
    'isPublic'
  ],
  computed: {
    auth () {
      return this.$store.getters['authentication/getAuthInfo']
    },
    completeFrom () {
      return this.$route.params.from
    },
    isPrivate () {
      const noFrame = (this.auth.frame && this.auth.frame === 'false') || false
      return this.isPublic && noFrame
    },
    orderResult () {
      const order = this.order
      let status = null
      let message = null
      if (order.orderReason === 'paid') {
        // 결제가 완료되었습니다.
        status = 'paid'
        message = this.locale.payment_paid
      } else if (order.orderReason === 'auth-failed') {
        // 카드인증에 실패했습니다.
        status = 'authFailed'
        message = this.locale.payment_auth_failed
      } else if (order.orderReason === 'system-error') {
        // 시스템에러가 발생했습니다.
        status = 'systemError'
        message = this.locale.payment_system_error
      } else if (order.orderReason === 'payment-duplication') {
        // 이미 결제되었습니다.
        status = 'paymentDuplication'
        message = this.locale.payment_payment_duplication
      } else if (order.orderReason === 'failed-signature') {
        // 암호화 오류가 발생했습니다.
        status = 'filedSignature'
        message = this.locale.payment_failed_signature
      } else if (order.orderReason === 'approval-fail') {
        // 카드 승인에 실패했습니다.
        status = 'approvalFail'
        message = this.locale.payment_approval_fail
      }
      return {
        status: status,
        message: message
      }
    }
  },
  mounted () {
    this.checkPrarms()
    this.$store.commit('loading', false)
    this.$store.commit('loading', true)
    this.$store.dispatch('coupon/getWaitCoupon').then((iids) => {
      if (iids) {
        this.$store.dispatch('coupon/useCoupons', iids)
        this.$store.commit('loading', false)
      }
      this.$store.commit('loading', false)
    })
    setTimeout(() => {
      window.scrollTo(0, 0)
    })
  },
  beforeDestroy () {
    this.completePayment()
    delete this.$route.params.from
  },
  data () {
    return {
      order: null
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    checkPrarms () {
      const params = {}
      window.location.search.replace(/[#?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
        params[key] = value
      })
      this.order = Object.assign({}, params)
      this.checkOrderId()
    },
    completePayment () {
      const searchParams = new URLSearchParams()
      const params = this.order
      Object.keys(params).forEach(key => {
        if (key !== 'commerce' && key !== 'orderId' && key !== 'orderStatus' && key !== 'orderReason') {
          searchParams.append(key, params[key])
        }
      })
      window.location.search = searchParams.toString()
    },
    checkOrderId () {
      const Store = this.$store
      if (this.order.remainAmenity) {
        const amenity = this.$store.getters['cart/getList'].find(x => x.cartId.includes('amenity'))
        if (amenity) {
          const site = this.order.site
          const cartId = `cart_${site}_amenity`
          this.$store.dispatch('submit/setSubmit', amenity).then((res) => {
          })
          localStorage.removeItem(cartId)
          Store.commit('cart/delList', cartId)
          let urlParams = new URLSearchParams(location.search)
          urlParams.delete('remainAmenity')
          location.search = urlParams.toString()
        }
      }
      if (this.order.orderId && this.order.orderStatus && this.order.orderReason) {
        if (this.order.orderReason === 'paid') {
          // 결제가 완료되었습니다.
          // alert('결제가 완료되었습니다.')
          this.$store.dispatch('payment/getOrderIdStatus', { orderId: this.order.orderId }).then((res) => {
            if (res) {
              res.forEach(function (cartId) {
                localStorage.removeItem(cartId)
                Store.commit('cart/delList', cartId)
              })
              // this.$store.dispatch('coupon/useCoupons', this.order.payload)
            }
          })
        } else if (this.order.orderReason === 'auth-failed') {
          // 카드인증에 실패했습니다.
          alert(this.locale.payment_auth_failed)
        } else if (this.order.orderReason === 'system-error') {
          // 시스템에러가 발생했습니다.
          alert(this.locale.alert_system_error)
        } else if (this.order.orderReason === 'payment-duplication') {
          // 이미 결제되었습니다.
          alert(this.locale.payment_payment_duplication)
          // this.$route.push({ name: 'main', params: { ln: this.lang } })
        } else if (this.order.orderReason === 'failed-signature') {
          // 암호화 오류가 발생했습니다.
          alert(this.locale.payment_failed_signature)
        } else if (this.order.orderReason === 'approval-fail') {
          // 카드 승인에 실패했습니다.
          alert(this.locale.payment_approval_fail)
        } else {
          alert(this.locale.alert_system_error)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.complete {
  padding: 80px 0 200px;
  text-align: center;
  p {
    padding-left: 30px;
    padding-right: 30px;
    font-size: 1.2em;
    &:before {
      content: "";
      display: block;
      height: 96px;
      margin-bottom: 30px;
      background: url('~@/assets/img/warn.png') 50% 50% / contain no-repeat;
    }
    &[data-status="paid"]:before {
      background-image: url('~@/assets/img/complete.png');
    }
  }
}
.btns {
  display: flex;
  max-width: 480px;
  margin: 0 auto;
  padding: 0 7px;
  .btn {
    flex: 1;
    width: calc(50% - 8px);
    margin: 0 8px;
    padding-left: 0;
    padding-right: 0;
    border-radius: 8px;
  }
}
</style>
